export class DeviceReportColumn {

  static readonly LOCAL_STORAGE_DISPLAYED_COLUMNS = 'deviceReportDisplayedColumns';
  static readonly displayedByDefault = [
    'shiftId',
    'phoneNumber',
    'imei',
    'sn',
    'appVersionCode',
    'appVersionName',
    'deviceManufacturer',
    'deviceModel',
    'deviceSdkVersion',
    'deviceOsVersion',
    'deviceOsUid',
  ];

  id: string;
  name: string;
  displayed: boolean;

  constructor(id: string, name: string, displayed: boolean = false) {
    this.id = id;
    this.name = name;
    this.displayed = displayed;
  }

  static columns(displayedColumns: string[]): DeviceReportColumn[] {

    const columns = [
      new DeviceReportColumn('shiftId', 'Shift ID'),
      new DeviceReportColumn('phoneNumber', 'Phone Number'),
      new DeviceReportColumn('imei', 'IMEI'),
      new DeviceReportColumn('sn', 'S/N'),
      new DeviceReportColumn('appVersionCode', 'App Version Code'),
      new DeviceReportColumn('appVersionName', 'App Version Name'),
      new DeviceReportColumn('deviceManufacturer', 'Manufacturer'),
      new DeviceReportColumn('deviceModel', 'Model'),
      new DeviceReportColumn('deviceSdkVersion', 'SDK Version'),
      new DeviceReportColumn('deviceOsVersion', 'OS Version'),
      new DeviceReportColumn('deviceOsUid', 'OS UID'),
    ];

    columns.forEach(column => {
      column.displayed = displayedColumns.some(value => value === column.id);
    });

    return columns;
  }
}
